import * as ACTIONS from "./actionTypes";

const initialState = {
  carEngines: [],
};

function carEnginesReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_CAR_ENGINES_SUCCESS: {
      return {
        ...state,
        ...{ carEngines: payload.list },
      };
    }
    default:
      return state;
  }
}

export default carEnginesReducer;
